var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-allocation-request-messages"},[_c('i',{staticClass:"far fa-info-circle info-icon"}),_vm._l((_vm.allocationRequestMessage),function(allocation){return _c('span',{key:allocation.key,staticClass:"allocation-request-message"},[_vm._v(" "+_vm._s(allocation.displayName)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }